import React, { Component } from "react";
import Container from "./styled";
import DropdownItem from "./dropDown";
import { Fade } from "react-awesome-reveal";

export default class Question extends Component {
  // Estado que determina si esta abierta o no la question
  state = {
    isActiveUno: false,
    isActiveDos: false,
    isActiveTres: false,
    isActiveCuatro: false,
    isActiveCinco: false,
    isActiveSeis: false,
    isActiveSiete: false,
    isActiveOcho: false,
    isActiveNueve: false,
    isActiveDiez: false,
  };

  // Toggle para cambiar el estado cuando se abre o se cierra cada una de las questions
  handleToggleUno = () => {
    this.setState({
      isActiveUno: !this.state.isActiveUno,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
    console.log(this.state.isActiveUno);
  };

  handleToggleDos = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: !this.state.isActiveDos,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleTres = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: !this.state.isActiveTres,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleCuatro = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: !this.state.isActiveCuatro,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleCinco = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: !this.state.isActiveCinco,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleSeis = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: !this.state.isActiveSeis,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleSiete = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: !this.state.isActiveSiete,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleOcho = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: !this.state.isActiveOcho,
      isActiveNueve: false,
      isActiveDiez: false,
    });
  };

  handleToggleNueve = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: !this.state.isActiveNueve,
      isActiveDiez: false,
    });
  };

  handleToggleDiez = () => {
    this.setState({
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      isActiveCuatro: false,
      isActiveCinco: false,
      isActiveSeis: false,
      isActiveSiete: false,
      isActiveOcho: false,
      isActiveNueve: false,
      isActiveDiez: !this.state.isActiveDiez,
    });
  };

  render() {
    const isActiveUno = this.state.isActiveUno;
    const isActiveDos = this.state.isActiveDos;
    const isActiveTres = this.state.isActiveTres;
    const isActiveCuatro = this.state.isActiveCuatro;
    const isActiveCinco = this.state.isActiveCinco;
    const isActiveSeis = this.state.isActiveSeis;
    const isActiveSiete = this.state.isActiveSiete;
    const isActiveOcho = this.state.isActiveOcho;
    const isActiveNueve = this.state.isActiveNueve;
    const isActiveDiez = this.state.isActiveDiez;
    return (
      <Container>
        {/* Title */}
        <h2>Nuestras preguntas más frecuentes</h2>
        {/* Questions Container */}
        <div className="questionsContainer">
          {/* Pregunta 1 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveUno == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Cuáles son los requisitos para asegurar mi bici?"
              clickFunction={this.handleToggleUno}
              isActive={this.state.isActiveUno}
            >
              Foto de la bicicleta (donde se vea una hoja que indique la fecha
              del día en que se está tomando la foto), factura de compra o
              presupuesto y la solicitud del seguro (la podés hacer online).
            </DropdownItem>
          </Fade>
          {/* Pregunta 2 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveDos == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Puedo contratar sin la factura?"
              clickFunction={this.handleToggleDos}
              isActive={this.state.isActiveDos}
            >
              Sí, podés conseguir un presupuesto en una bicicletería, o
              SeguroBici puede conseguirlo por vos.
            </DropdownItem>
          </Fade>
          {/* Pregunta 3 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveTres == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Cuándo empieza a regir mi póliza?"
              clickFunction={this.handleToggleTres}
              isActive={this.state.isActiveTres}
            >
              Desde las 12 hs del día siguiente una vez contratado
            </DropdownItem>
          </Fade>
          {/* Pregunta 4 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveCuatro == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Los precios cubren el total de la bici?"
              clickFunction={this.handleToggleCuatro}
              isActive={this.state.isActiveCuatro}
            >
              Si. Cubren el total de la Bici
            </DropdownItem>
          </Fade>
          {/* Pregunta 5 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveCinco == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Hay un tiempo mínimo de permanencia?"
              clickFunction={this.handleToggleCinco}
              isActive={this.state.isActiveCinco}
            >
              No, podés seguir o dar de baja el seguro cuando desees.
            </DropdownItem>
          </Fade>
          {/* Pregunta 6 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveSeis == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Cuales son las formas de pago?"
              clickFunction={this.handleToggleSeis}
              isActive={this.state.isActiveSeis}
            >
              Tarjeta de Credito Bancarizada y CBU.
            </DropdownItem>
          </Fade>
          {/* Pregunta 7 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveSiete == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="La uso para Delivery, ¿la puedo asegurar?"
              clickFunction={this.handleToggleSiete}
              isActive={this.state.isActiveSiete}
            >
              Si, tenemos cobertura para Delivery
            </DropdownItem>
          </Fade>
          {/* Pregunta 8 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveOcho == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Que me piden en caso de un siniestro?"
              clickFunction={this.handleToggleOcho}
              isActive={this.state.isActiveOcho}
            >
              Contactarse con Seguro Bici y hacer la denuncia policial.
              SeguroBici acompañará al ciclista en todo el proceso del
              Siniestro.
            </DropdownItem>
          </Fade>
          {/* Pregunta 9 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveNueve == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Dónde llamar en caso de siniestro?"
              clickFunction={this.handleToggleNueve}
              isActive={this.state.isActiveNueve}
            >
              Contactanos al 0810-220-2373
            </DropdownItem>
          </Fade>
          {/* Pregunta 10 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className={
              this.state.isActiveDiez == true
                ? "dropDownContainerOpen"
                : "dropDownContainer"
            }
          >
            <DropdownItem
              title="¿Cuál es la diferencia entre Robo y Hurto?"
              clickFunction={this.handleToggleDiez}
              isActive={this.state.isActiveDiez}
            >
              Robo: Apoderamiento ilegítimo del bien con el uso de la violencia
              o la intimidación de las personas.
              <br></br>
              <br></br>
              Hurto: Apoderamiento ilegítimo del bien sin uso de la violencia o
              la intimidación de las personas
            </DropdownItem>
          </Fade>
        </div>
      </Container>
    );
  }
}
